<div class="d-flex gap-3 cards-container">
  <mat-card class="text-black w-50 p-3 overflow-auto crm-scroll position-relative">
    <mat-card-header class="ticket-header">
      <mat-card-title class="text-center w-100 justify-content-center"
        >{{ 'ticket_system.new_ticket' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="ticket-form">
        <app-input
          labelType="floating"
          [formControl]="ticketForm.controls.name"
          (focusout)="ticketForm.controls.name.markAsTouched()"
          [invalid]="ticketForm.controls.name.touched && ticketForm.controls.name.invalid"
          [required]="true"
          placeholder="{{ 'ticket_system.enter_a_topic' | translate }}"
        />
        <app-input
          labelType="floating"
          inputType="text-area"
          [formControl]="ticketForm.controls.text"
          (focusout)="ticketForm.controls.text.markAsTouched()"
          [invalid]="ticketForm.controls.text.touched && ticketForm.controls.text.invalid"
          [required]="true"
          placeholder="{{ 'enter_text' | translate }}"
        />

        @if (ticketFiles.length) {
          <div class="d-flex flex-column w-100">
            <mat-card-header class="ticket-header">
              <mat-card-title class="text-center w-100 justify-content-center"
                >{{ 'ticket_system.files' | translate }}
              </mat-card-title>
            </mat-card-header>
            <div class="image-list d-flex justify-content-center flex-wrap gap-2 w-100">
              @for (img of ticketFiles; track img; let i = $index) {
                <div class="img-box">
                  <app-button btnType="icon" class="deletePhoto" (click)="deletePhoto(i)">
                    <app-icon>delete</app-icon>
                  </app-button>
                  <img class="container-img no-select" [src]="img.url" alt="{{ i }}" />
                </div>
              }
            </div>
          </div>
        }

        <div class="ticket-actions">
          <app-button (click)="openFileUpload()">{{ 'ticket_system.attach_a_file' | translate }}</app-button>
          <app-button (click)="onCreateTicket()" [disabled]="ticketForm.invalid"
            >{{ 'ticket_system.add_ticket' | translate }}
          </app-button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="ticket-list-card text-black w-100 p-3 overflow-auto crm-scroll">
    <mat-card-header class="ticket-header">
      <mat-card-title class="text-center w-100 justify-content-center"
        >{{ 'ticket_system.list_of_tickets' | translate }}
      </mat-card-title>
    </mat-card-header>
    <app-search (onValueChange)="onSearchChange($event)"></app-search>

    @if (isLoader) {
      <div class="d-flex justify-content-center">
        <app-loader size="small"></app-loader>
      </div>
    } @else {
      <mat-card-content class="d-flex flex-column gap-1 ticket-list crm-scroll">
        @for (ticket of ticketList; track ticket) {
          <mat-card (click)="onOpenCard(ticket)" class="ticket-card">
            <mat-card-content class="d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column">
                <mat-panel-title>{{ 'ticket_system.code' | translate }}: {{ ticket.code }}</mat-panel-title>
                <mat-panel-title>{{ 'ticket_system.name' | translate }}: {{ ticket.name }}</mat-panel-title>
                <mat-panel-title
                  >{{ 'ticket_system.date' | translate }}: {{ formatDate(ticket.created_at) }}
                </mat-panel-title>
              </div>
              <div
                class="status-circle"
                [ngClass]="ticket.status"
                [matTooltip]="
                  ('ticket_system.status' | translate) + ': ' + ('ticket_system.' + ticket.status | translate)
                "
              ></div>
            </mat-card-content>
          </mat-card>
        }
      </mat-card-content>
    }

    <div>
      <ng-container>
        <table-pagination
          [length]="totalItems"
          [pageSizeOptions]="[25, 50, 75, 100]"
          (page)="onPaginationChange($event)"
          [pageIndex]="currentIndex"
          [pageSize]="params.take"
          class="mat-paginator-sticky"
        >
        </table-pagination>
      </ng-container>
    </div>
  </mat-card>
</div>
